import { IconButton, Skeleton } from '@mui/material';
import { memo } from 'react';

const LOADING_DAYS = [0, 1, 2, 3, 4, 5, 6];

// Segnaposto dei giorni mentre il centro corrente carica la settimana, come nel WeekPicker
export const MultiStoreLoadingDates = memo(
  function MultiStoreLoadingDates(): JSX.Element {
    return (
      <>
        {LOADING_DAYS.map((index) => (
          <IconButton key={index} className="date-container">
            <Skeleton variant="circular" width="100%" height="100%" />
          </IconButton>
        ))}
      </>
    );
  }
);
